import { init as setup_modal, hide as hide_modal } from 'ui/modal';
import { exclusion_string } from 'booking-widget/v1/common/util';
import { get as get_cache } from 'utils/cache';
import { esc_html } from 'utils/strings';

// only creates at most one modal element per page
export const init = (options) => {
    if (!options) {
        options = {};
    }

    let modal_id = options.id ? options.id : 'bwgp-widget';
    let control_el = options.control;
    let vessel_type = options.vessel_type || false;
    let hide_toddlers = options.hide_toddlers || false;
    let is_tour_specific = options.is_tour_specific || false;
    let widget_el = $('#' + modal_id);
    let MAX_CAPACITY = 49; // will be replaced when results load.
    let capacity = MAX_CAPACITY;
    let inital_counts = {
        adult: options.adult ? (parseInt(options.adult) || 2) : 2,
        child: options.child ? (parseInt(options.child) || 0) : 0,
        toddler: options.toddler ? (parseInt(options.toddler) || 0) : 0,
    }
    // booking_settings should already be cached
    let age_ranges = get_cache('booking_settings-age_ranges');

    control_el
        .addClass('bwgp-widget-opener')
        .attr('data-ts-modal-open', modal_id)
        .attr('data-hide-toddlers', (hide_toddlers ? 1 : 0))
        .attr('data-vessel-type', vessel_type ? vessel_type : '')
    ;

    let html = `
        <div class="bw-modal bwgp-widget" id="${modal_id}" aria-hidden="true">
            <div class="bw-modal__overlay" tabindex="-1" data-ts-modal-close>
                <div class="bw-modal__container" role="dialog" aria-modal="true" aria-labelledby="${modal_id}-title">
                    <main class="bw-modal__content">
                        <h3 id="${modal_id}-title" class="bwgp-widget__header" data-ts-modal-close>
                            <span class="bw-gray">Guests</span>
                            <span class="bwgp-widget--toggle bw__icomoon bw__icomoon--expand_less"></span>
                        </h3>
                        <div class="bwgp-widget__guest-row">
                            <div class="bwgp-widget__guest-col bwgp-widget__input-group">
                                <a href="#"  class="bw__icomoon bw__icomoon--minus bwgp-widget__input--minus"></a>
                                <div contenteditable="true" spellcheck="false" class="bwgp-widget__guest-count bwgp-widget__guest-count--adult">${inital_counts.adult}</div>
                                <a href="#" class="bw__icomoon bw__icomoon--plus bwgp-widget__input--plus"></a>
                            </div>
                            <div class="bwgp-widget__guest-col">
                                Adult (${esc_html(age_ranges.adult.start || 13)} &amp; older)
                            </div>
                        </div>
                        <div class="bwgp-widget__guest-row">
                            <div class="bwgp-widget__guest-col bwgp-widget__input-group">
                                <a href="#"  class="bw__icomoon bw__icomoon--minus bwgp-widget__input--minus"></a>
                                <div contenteditable="true" spellcheck="false" class="bwgp-widget__guest-count bwgp-widget__guest-count--child">${inital_counts.child}</div>
                                <a href="#"  class="bw__icomoon bw__icomoon--plus bwgp-widget__input--plus"></a>
                            </div>
                            <div class="bwgp-widget__guest-col">
                                Child (${esc_html(age_ranges.child.start || 6)}-${esc_html(age_ranges.child.end || 12)})
                            </div>
                        </div>
                        <div class="bwgp-widget__guest-row bwgp-widget__guest-row--toddler">
                            <div class="bwgp-widget__guest-col bwgp-widget__input-group">
                                <a href="#"  class="bw__icomoon bw__icomoon--minus bwgp-widget__input--minus"></a>
                                <div contenteditable="true" spellcheck="false" class="bwgp-widget__guest-count bwgp-widget__guest-count--toddler">${inital_counts.toddler}</div>
                                <a href="#"  class="bw__icomoon bw__icomoon--plus bwgp-widget__input--plus"></a>
                            </div>
                            <div class="bwgp-widget__guest-col">
                                Toddler (${esc_html(age_ranges.toddler.start || 3)}-${esc_html(age_ranges.toddler.end || 5)})
                            </div>
                        </div>
                        <div class="bwgp-widget__details"></div>
                    </main>
                </div>
            </div>
        </div>
    `;

    let opener_el = $();
    setup_modal({
        html: html,
        on_shown: function(e, params) {
            let modal_el = $('#' + modal_id);
            opener_el = params.opener_el;
            let bgwp_widget = $('.bw-modal__container',modal_el);
            let position = opener_el.offset();
            let offset_t = position.top - $(window).scrollTop();
            let hide_toddlers = opener_el.attr('data-hide-toddlers');
            let vessel_type = opener_el.attr('data-vessel-type');
            capacity = (is_tour_specific && opener_el[0].hasAttribute('data-capacity')) ? opener_el.attr('data-capacity') : MAX_CAPACITY;
            
            // show or hide things based on opener
            if (hide_toddlers == 1) {
                $('.bwgp-widget__guest-row--toddler', modal_el).hide();
            }
            else {
                $('.bwgp-widget__guest-row--toddler', modal_el).show();
            }
            populate_exclusions(opener_el);

            // position it
            bgwp_widget.css({top: offset_t + 'px', left: position.left});

            if (bgwp_widget.innerWidth() < opener_el.innerWidth()) {
                // total width of the control - padding
                let width = opener_el.outerWidth() - (bgwp_widget.innerWidth() - bgwp_widget.width());
                bgwp_widget.css({width: width + 'px'});
            }
        },
        on_hidden: function() {
            if (options.refresh_control) {
                options.refresh_control(get_guest_counts(widget_el), opener_el);
            }
            opener_el = $();
        }
    });

    widget_el = $('#' + modal_id);
    $('.bwgp-widget__input--plus, .bwgp-widget__input--minus', widget_el).on('click', function(e) {
        e.preventDefault();
        let input_el = $(this).closest('.bwgp-widget__input-group').find('.bwgp-widget__guest-count');
        let change = 0;
        if ($(this).hasClass('bwgp-widget__input--plus')) {
            change = 1;
        }
        else {
            change = -1;
        }
        let min = input_el.hasClass('bwgp-widget__guest-count--adult') ? 1 : 0;
        let count = handle_count_change(input_el.text(), min, capacity, change);
        input_el.text(count);
        
    });

    $('.bwgp-widget__guest-count', widget_el)
        .on('blur', function() {
            let min = $(this).hasClass('bwgp-widget__guest-count--adult') ? 1 : 0;
            let num = handle_count_change($(this).text(), min, capacity, 0);
            $(this).text(num);
        })
        .on('keydown', function(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                let min = $(this).hasClass('bwgp-widget__guest-count--adult') ? 1 : 0;
                let num = handle_count_change($(this).text(), min, capacity, 0);
                $(this).text(num);
                hide_modal(widget_el);
            }
        })
    ;

    function handle_count_change(val, min, max, change) {
        let num = parseInt(val) || 0;
        num += change;
        return Math.max(Math.min(num, max), min);
    }

    /**
     * Construct the exclusion text based of the attributes in opener_el
     */
    function populate_exclusions(opener_el) {
        let details_el = $('.bwgp-widget__details', widget_el);
        details_el.empty();

        let exclusions = opener_el.attr('data-exclusions');
        if (!exclusions || exclusions == '') {
            return;
        }
        
        exclusions = JSON.parse(exclusions);
        
        for (let vessel_type in exclusions) {
            let str = '';
            let combo = exclusions[vessel_type].split('-');
            if (combo.length !== 2) {
                continue;
            }
            let toddlers_allowed = combo[0];
            let pregnant_allowed = combo[1];

            if (Object.keys(exclusions).length > 1) {
                str += vessel_type == 'catamaran' ? 'Catamaran Tours: ' : 'Raft Tours: ';
            }
            str += exclusion_string(toddlers_allowed, pregnant_allowed);
            
            details_el.append('<p class="bw-gray bgp-exclusion">*' + str + '</p>');
        }
    }

};

export const get_guest_counts = (widget_el) => {
    let guest_counts = { adult: 1, child: 0, toddler: 0 };
    $('.bwgp-widget__guest-count', widget_el).each(function() {
        if ($(this).hasClass('bwgp-widget__guest-count--adult')) {
            guest_counts.adult = parseInt($(this).text()) || 1;
        }
        else if ($(this).hasClass('bwgp-widget__guest-count--child')) {
            guest_counts.child = parseInt($(this).text()) || 0;
        }
        else if ($(this).hasClass('bwgp-widget__guest-count--toddler')) {
            guest_counts.toddler = parseInt($(this).text()) || 0;
        }
    });
    return guest_counts;
};


export const set_guest_counts = (widget_el, guest_counts) => {
    $('.bwgp-widget__guest-count', widget_el).each(function() {
        if ($(this).hasClass('bwgp-widget__guest-count--adult')) {
            $(this).text(parseInt(guest_counts.adult) || 1);
        }
        else if ($(this).hasClass('bwgp-widget__guest-count--child')) {
            $(this).text(parseInt(guest_counts.child) || 0);
        }
        else if ($(this).hasClass('bwgp-widget__guest-count--toddler')) {
            $(this).text(parseInt(guest_counts.toddler) || 0);
        }
    });
};